import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { amitContext } from "../context/amit";

function ScrollToTop() {
  const { pathname } = useLocation();

  const {current} = useContext(amitContext)



  useEffect(() => {
    if(current == '/') {
    window.scrollTo(0,0);

    }




  }, [current]);
  return null;
}

export default ScrollToTop;
